import React from "react";

const About = () => {
  return (
    <div id="about" className="py-20 bg-secondary text-primary">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-playfair font-bold mb-6">About Me</h2>
        <p className="font-quicksand text-lg">
          I am a results-driven IT professional with over three years of
          experience providing exceptional technical support across various
          platforms. I successfully streamlined support communication by
          implementing a ticketing system, reducing user inquiry response times
          from 24 hours to under 2 hours, significantly enhancing customer
          satisfaction and engagement. I am eager to leverage my expertise in a
          dynamic remote support environment.
        </p>
      </div>
    </div>
  );
};

export default About;
